import { render, staticRenderFns } from "./CashRegisterUpdate.vue?vue&type=template&id=5b24dc31"
import script from "./CashRegisterUpdate.vue?vue&type=script&lang=js"
export * from "./CashRegisterUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports